﻿import React, { useState } from 'react';
import { SortableCardData } from '../../models/Common/sortable-card-data';

import CheckBox from 'devextreme-react/check-box';

export interface Props {
    cardData: SortableCardData;
    index?: number;
    showIndex?: boolean;
    useCheckBox: boolean;
    onValueChanged: (data: SortableCardData) => void;
}

export default function SortableCard(props: Props) {
    const [isChecked, setIsChecked] =
        useState<boolean>(false);

    if (props.useCheckBox) {
        return (
            <div className="sortable-card dx-card">
                <div className="sortable-card-marker" style={{ backgroundColor: props.cardData.markerColor }}></div>
                <div className="sortable-card-content">{props.cardData && props.cardData.content}</div>
                <CheckBox text="Include" value={isChecked} onValueChanged={onValueChanged} />
            </div>
        );
    }
    else {
        return (
            <div className="sortable-card dx-card">
                <div className="sortable-card-marker" style={{ backgroundColor: props.cardData.markerColor }}>
                    <div className="sortable-card-marker-index">{props.showIndex && props.index + 1}</div>
                </div>
                <div className="pw-margin-left-05">
                    <div className="sortable-card-subject">{props.cardData && props.cardData.subject}</div>
                    <div className="sortable-card-content">{props.cardData && props.cardData.content}</div>
                </div>
            </div>
        );
    }


    function onValueChanged(e: any) {

        console.log("onValueChanged (SortableCard)");
        console.log(e);
        setIsChecked(!isChecked);

        let data = props.cardData;
        data.isChecked = e.value;

        if (props.onValueChanged)
            props.onValueChanged(data);


    }

}

